import axiosInstance from './axiosInstance';

export const youtubeApi = {
  getAll: async () => {
    try {
      const response = await axiosInstance.get('/youtube-videos');
      console.log('YouTube API response:', {
        status: response.status,
        data: response.data,
        isArray: Array.isArray(response.data)
      });
      return response;
    } catch (error) {
      console.error('YouTube API error:', error);
      throw error;
    }
  },
  getQRCode: (customVideoId) => axiosInstance.get(`/youtube-videos/video/${customVideoId}/qr`),
  create: (video) => axiosInstance.post('/youtube-videos', video),
  update: (id, video) => axiosInstance.put(`/youtube-videos/${id}`, video),
  delete: (id) => axiosInstance.delete(`/youtube-videos/${id}`)
};

export default youtubeApi;
